import { ASSISTANT_STARTERS, type AssistantStarter } from "@ceo-cmd/shared";

export function AssistantPresets({
  onSelect,
}: {
  onSelect: (preset: AssistantStarter) => void;
}) {
  return (
    <div className="w-full max-w-2xl">
      <p className="mb-3 text-center text-sm text-muted-foreground">
        Start with a command prompt
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {ASSISTANT_STARTERS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className="rounded-full border border-border bg-card px-3 py-1.5 text-left text-sm text-foreground transition hover:border-brand/40 hover:bg-brand-soft/40"
            onClick={() => onSelect(preset)}
          >
            {preset.name}
          </button>
        ))}
      </div>
    </div>
  );
}
